import { render, staticRenderFns } from "./VizletHeader.vue?vue&type=template&id=4c775b36&scoped=true&"
import script from "./VizletHeader.vue?vue&type=script&lang=js&"
export * from "./VizletHeader.vue?vue&type=script&lang=js&"
import style0 from "./VizletHeader.vue?vue&type=style&index=0&id=4c775b36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c775b36",
  null
  
)

export default component.exports